import React, {useState, useEffect} from 'react';
import 'react-multi-carousel/lib/styles.css';
import {CircularProgress, Grid, Typography} from '@material-ui/core';
import dashboardService from '../service';
import Carousel from 'react-multi-carousel';
import Title from '../../../components/Title';
import Chart from 'react-apexcharts';
import {
  getMonthName,
  months,
  responsive,
  responsiveCards,
  responsiveMedium,
  returnValues,
  returnValuesBykeys,
  returnValuesTest,
} from '../service/utils';
import {KeyboardDatePicker} from '@material-ui/pickers';
import DataCard from './DataCard';
import moment from 'moment';
import DrawTableDash from '../../../components/DrawTableDash';

const styles = {
  margin: {
    marginTop: 15,
    marginBottom: 15,
  },
  viewCharts: {
    display: 'flex',
    flexWrap: 'nowrap',
    marginTop: 15,
  },
  containerChart: {
    minWidth: '45%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    margin: '0 10px 10px 0',
  },
  containerChartLine: {
    width: '75%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    marginTop: 20,
  },
  containerChartTable: {
    width: '75%',
    padding: 10,
  },
  legend: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
  title: {textAlign: 'center', marginTop: 10, marginBottom: 20},
  flexEnd: {width: '100%', display: 'flex', justifyContent: 'flex-end'},
  datePicker: {
    borderRadius: '40px',
    height: 50,
    width: 'fit-content',
    border: 'solid 1px #d3d3d3',
    marginBottom: 20,
    marginLeft: 5,
  },
};

const OnboardingGraph = () => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [resultsTable, setResultsTable] = useState([]);
  const [, setKeysPeriod] = useState([]);
  const [, setResultsPeriod] = useState();
  const [resultsMonth, setResultsMonth] = useState({
    android: [
      {
        count: 0,
      },
    ],
    ios: [
      {
        count: 0,
      },
    ],
    site: [
      {
        count: 0,
      },
    ],
    none: [
      {
        count: 0,
      },
    ],
  });
  const [startDate, setStartDate] = useState(new Date('11-07-2024'));
  const [endDate, setEndDate] = useState(new Date());
  const [date, setDate] = useState(new Date());
  const [totalData, setTotalData] = useState(0);
  const [totalDataMonth, setTotalDataMonth] = useState(0);
  const [totalDataPlataform, setTotalDataPlataform] = useState(0);

  const GetData = async () => {
    setLoading(true);
    dashboardService
      .getUsersOnboarding({
        year: date.getFullYear(),
        month: date.getMonth(),
        date,
        startDate,
        endDate,
      })
      .then(async ({data}) => {
        const resultMonthR = data?.resultsByMonth.reduce((acc, item) => {
          return {
            ...acc,
            [item.registration_platform]: [
              ...(acc[item.registration_platform] ?? []),
              item,
            ],
          };
        }, {});

        setTotalDataMonth(data?.countByMonth);
        setTotalDataPlataform(data?.countByMonthByPlataform);

        setResultsMonth({
          android: [
            {
              count:
                resultMonthR['android'] && resultMonthR['android'][0]
                  ? resultMonthR['android'][0].count
                  : 0,
            },
          ],
          ios: [
            {
              count:
                resultMonthR['ios'] && resultMonthR['ios'][0]
                  ? resultMonthR['ios'][0].count
                  : 0,
            },
          ],
          site: [
            {
              count:
                resultMonthR['site'] && resultMonthR['site'][0]
                  ? resultMonthR['site'][0].count
                  : 0,
            },
          ],
          none: [
            {
              count:
                resultMonthR['null'] && resultMonthR['null'][0]
                  ? resultMonthR['null'][0].count
                  : 0,
            },
          ],
        });

        const resultR = data?.results
          ?.map(item => {
            return {...item, categories: getMonthName(item.month)};
          })
          .reduce((acc, item) => {
            return {
              ...acc,
              [item.registration_platform]: [
                ...(acc[item.registration_platform] ?? []),
                item,
              ],
            };
          }, {});

        let test = [];
        Object.values(resultR).map(key => {
          return test.push(...key);
        });

        const formatedData = [
          {
            name: 'Total',
            title: 'Total de usuários onboarding',
            color: '#70AD47',
            data: returnValuesTest(test),
            total: data?.total || 0,
            textColor: '#fff',
          },
          {
            name: 'Total com plataforma',
            title: 'Total de usuários onboarding com plataforma',
            color: '#5B9BD5',
            data: returnValuesTest(test.filter(t => !!t.registration_platform)),
            total: data?.totalByPlataform || 0,
            textColor: '#fff',
          },
          {
            name: 'Android',
            title: 'Usuários onboarding - Android',
            color: '#4472C4',
            data: returnValues(resultR['android']),
            total:
              resultR['android']?.reduce(function(accumulator, value) {
                return accumulator + value.count;
              }, 0) || 0,
            textColor: '#fff',
          },
          {
            name: 'IOS',
            title: 'Usuários onboarding  - IOS',
            color: '#ED7D31',
            data: returnValues(resultR['ios']),
            total:
              resultR['ios']?.reduce(function(accumulator, value) {
                return accumulator + value.count;
              }, 0) || 0,
          },
          {
            name: 'Site',
            title: 'Usuários onboarding - Site',
            color: '#A5A5A5',
            data: returnValues(resultR['site']),
            total:
              resultR['site']?.reduce(function(accumulator, value) {
                return accumulator + value.count;
              }, 0) || 0,
          },
          {
            name: 'Sem plataforma',
            title: 'Usuários onboarding sem plataforma',
            color: '#FFC000',
            data: returnValues(resultR['null']),
            total:
              resultR['null']?.reduce(function(accumulator, value) {
                return accumulator + value.count;
              }, 0) || 0,
          },
        ];

        setTotalData(data?.total);
        setResults(formatedData);

        const response = formatedData.map(d => {
          const dataPerc = d.data.map((dd, index) => {
            const t = formatedData[0].data[index]
              ? ((dd * 100) / formatedData[0].data[index]).toFixed(2)
              : 0;
            return {dd: dd || 0, t};
          });
          return {...d, dataPerc};
        });
        setResultsTable(response);

        const resultsByDay = data?.resultsByDay?.reduce((acc, item) => {
          return {
            ...acc,
            [item.day]: [...(acc[item.day] ?? []), item],
          };
        }, {});

        if (resultsByDay) {
          let returnPer = [];

          Object.values(resultsByDay).map(key => {
            return returnPer.push(...key);
          });

          const period = returnPer.reduce((acc, item) => {
            return {
              ...acc,
              [item.registration_platform]: [
                ...(acc[item.registration_platform] ?? []),
                item,
              ],
            };
          }, {});

          const formatedPeriod = [
            {
              name: 'Android',
              title: 'Número de usuários  - Android',
              color: '#4472C4',
              data: returnValuesBykeys(
                period['android'],
                Object.keys(resultsByDay),
              ),
              total:
                period['android']?.reduce(function(accumulator, value) {
                  return accumulator + value.count;
                }, 0) || 0,
              textColor: '#fff',
            },
            {
              name: 'IOS',
              title: 'Número de usuários  - IOS',
              color: '#ED7D31',
              data: returnValuesBykeys(
                period['ios'],
                Object.keys(resultsByDay),
              ),
              total:
                period['ios']?.reduce(function(accumulator, value) {
                  return accumulator + value.count;
                }, 0) || 0,
            },
            {
              name: 'Site',
              title: 'Número de usuários  - Site',
              color: '#FFC000',
              data: returnValuesBykeys(
                period['site'],
                Object.keys(resultsByDay),
              ),
              total:
                period['site']?.reduce(function(accumulator, value) {
                  return accumulator + value.count;
                }, 0) || 0,
            },
          ];

          setKeysPeriod(Object.keys(resultsByDay));
          setResultsPeriod(formatedPeriod);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    GetData();
  }, [startDate, endDate, date]);

  return (
    <div style={styles.margin}>
      <Typography
        component="h1"
        variant="h6"
        color="inherit"
        noWrap
        style={styles.title}>
        Usuários onboarding por plataforma
      </Typography>

      {loading ? (
        <div className="flex-col center-a center-b">
          <CircularProgress size={100} />
        </div>
      ) : (
        <>
          <div style={styles.flexEnd}>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data inicial"
                value={startDate}
                minDate={new Date('11-07-2024')}
                onChange={dateForm => {
                  // if (
                  //   new Date(dateForm) > endDate ||
                  //   endDate - new Date(dateForm) > 365 * 24 * 60 * 60 * 1000
                  // )
                  //   setEndDate(
                  //     new Date(
                  //       new Date(dateForm).getTime() +
                  //         365 * 24 * 60 * 60 * 1000,
                  //     ),
                  //   );
                  setStartDate(new Date(dateForm));
                }}
                format="DD/MM/YYYY"
              />
            </div>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data final"
                minDate={startDate}
                value={endDate}
                onChange={dateForm => {
                  // if (
                  //   new Date(dateForm) < startDate ||
                  //   new Date(dateForm) - startDate > 365 * 24 * 60 * 60 * 1000
                  // )
                  //   setStartDate(
                  //     new Date(
                  //       new Date(dateForm).getTime() -
                  //         365 * 24 * 60 * 60 * 1000,
                  //     ),
                  //   );
                  setEndDate(new Date(dateForm));
                }}
                format="DD/MM/YYYY"
              />
            </div>
          </div>

          {resultsMonth && (
            <Carousel responsive={responsiveCards}>
              <DataCard
                title={<span>Total de usuários onboarding</span>}
                value={totalDataMonth || 0}
              />
              <DataCard
                title={<span>Total de usuários onboarding com plataforma</span>}
                value={totalDataPlataform || 0}
              />
              <DataCard
                title={<span>Usuários onboarding - Android</span>}
                value={resultsMonth['android'][0]?.count || 0}
              />
              <DataCard
                title={<span>Usuários onboarding - IOS</span>}
                value={resultsMonth['ios'][0]?.count || 0}
              />
              <DataCard
                title={<span>Usuários onboarding - Site</span>}
                value={resultsMonth['site'][0]?.count || 0}
              />
              <DataCard
                title={<span>Usuários onboarding sem plataforma</span>}
                value={resultsMonth['none'][0]?.count || 0}
              />
            </Carousel>
          )}

          <div style={{marginTop: 10}} />

          <div style={styles.flexEnd}>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione ano"
                value={date}
                onChange={dateForm => setDate(new Date(dateForm))}
                views={['year']}
                yearsOrder="desc"
                format=" YYYY"
              />
            </div>
          </div>

          {results?.length > 0 && (
            <>
              <Grid container>
                <Grid container xs={12}>
                  {results?.map(item => {
                    return (
                      <Grid item xs={6}>
                        <div id="chart" style={styles.containerChart}>
                          <Title
                            fontWeight="normal"
                            size="medium"
                            align="center">
                            {item.title}
                          </Title>
                          <span style={styles.legend}>
                            {date.getFullYear()}
                          </span>
                          <Chart
                            options={{
                              colors: [item.color],
                              chart: {
                                type: 'bar',
                                height: 350,
                              },
                              plotOptions: {
                                bar: {
                                  borderRadius: 4,
                                  borderRadiusApplication: 'end',
                                  horizontal: true,
                                  dataLabels: {
                                    position: 'top',
                                  },
                                },
                              },
                              dataLabels: {
                                enabled: true,
                                textAnchor: 'end',
                                padding: 10,
                                style: {
                                  fontSize: '12px',
                                  colors: [item.textColor],
                                },
                              },
                              tooltip: {
                                enabled: false,
                              },
                              stroke: {
                                enabled: false,
                              },
                              xaxis: {
                                categories: months,
                              },
                            }}
                            series={[
                              {
                                data: item.data,
                              },
                            ]}
                            type="bar"
                            height={350}
                          />
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>

              <div style={{marginTop: 10}} />

              <Carousel responsive={responsiveMedium}>
                <div id="chart" style={styles.containerChart}>
                  <Title fontWeight="normal" size="medium" align="center">
                    Total de usuários onboarding - Percentual{' '}
                  </Title>
                  <span style={styles.legend}>{date.getFullYear()}</span>
                  <Chart
                    options={{
                      chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true,
                        stackType: '100%',
                      },
                      responsive: [
                        {
                          breakpoint: 480,
                          options: {
                            legend: {
                              position: 'bottom',
                              offsetX: -10,
                              offsetY: 0,
                            },
                          },
                        },
                      ],
                      plotOptions: {
                        bar: {
                          horizontal: false,
                        },
                      },
                      xaxis: {
                        categories: months,
                      },
                    }}
                    series={results?.slice(2)}
                    type="bar"
                    height={500}
                  />
                </div>
                <div id="chart" style={styles.containerChart}>
                  <Title fontWeight="normal" size="medium" align="center">
                    Total de usuários onboarding - Quantidade
                  </Title>
                  <span style={styles.legend}>{date.getFullYear()}</span>
                  <Chart
                    options={{
                      chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                          enabled: false,
                        },
                      },
                      dataLabels: {
                        enabled: true,
                        background: 'none',
                        textAnchor: 'end',
                      },
                      stroke: {
                        curve: 'straight',
                      },
                      xaxis: {
                        categories: months,
                      },
                    }}
                    series={results?.slice(2)}
                    type="line"
                    height={500}
                  />
                </div>
              </Carousel>

              <div style={{marginTop: 15}} />

              <Title fontWeight="normal" size="medium" align="center">
                Total de usuários onboarding - Percentual e Quantidade
              </Title>
              <span style={styles.legend}>{date.getFullYear()}</span>

              <div id="chart" style={styles.containerChartTable}>
                {DrawTableDash(
                  months,
                  resultsTable.map(item => {
                    return [
                      {dd: item.name === 'all' ? 'Total' : item.name},
                      {dd: item.total},
                      {
                        dd: `${
                          totalData > 0
                            ? ((item.total * 100) / totalData).toFixed(2)
                            : 0
                        }% `,
                      },
                      ...item.dataPerc,
                    ];
                  }),
                  'partners-to-xls',
                  'Onboarding',
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default OnboardingGraph;
